import { render, staticRenderFns } from "./SetReservation.vue?vue&type=template&id=0bb97d89&"
import script from "./SetReservation.vue?vue&type=script&lang=js&"
export * from "./SetReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports